import React from 'react';

export const BloctelLegalMention = () => (
  <p className="-mt-3 leading-[15px] text-xs text-sonic-silver">
    Conformément aux dispositions légales, vous êtes informé que vous pouvez vous inscrire sur la liste d&apos;opposition au démarchage
    téléphonique
    <a className="underline ml-1" href="https://www.bloctel.gouv.fr" target="_blank" rel="noreferrer">
      Bloctel
    </a>
    .
  </p>
);
